import * as styles from 'pkg/config/styles';

import rgba from 'pkg/rgba';

export const dayHighlight = {
	disabled: 'var(--color-surface-disabled, #e8e8e8)',
	active: rgba(styles.palette.main.actionableLinkColor),
	idle: 'var(--color-surface-primary, white)',
	'outside-range': 'transparent',
	'inside-selected-range': styles.palette.blue[400],
};

export const dayForeground = {
	disabled: '#9d9d9d',
	active: styles.palette.white,
	idle: '#303030',
	'outside-range': '#d7d7d7',
	'inside-selected-range': styles.palette.white,
};

export const dayCursor = {
	disabled: 'not-allowed',
	active: 'pointer',
	idle: 'pointer',
	'outside-range': 'default',
	'inside-selected-range': 'default',
};

export const dayWeight = {
	disabled: styles.font.weight.normal,
	active: styles.font.weight.normal,
	idle: styles.font.weight.normal,
	'outside-range': styles.font.weight.normal,
	'inside-selected-range': styles.font.weight.normal,
};

export const dayHoverBg = {
	disabled: 'var(--color-surface-disabled, #e8e8e8)',
	active: '#0552c5',
	idle: 'var(--color-surface-secondary, #edf1fb)',
	'outside-range': 'transparent',
	'inside-selected-range': styles.palette.blue[400],
};

export const dayHoverFg = {
	disabled: '#9d9d9d',
	active: styles.palette.white,
	idle: '#0066ff',
	'outside-range': 'transparent',
	'inside-selected-range': styles.palette.white,
};
